import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=102b2c67"
import script from "./Shop.vue?vue&type=script&lang=ts"
export * from "./Shop.vue?vue&type=script&lang=ts"
import style0 from "./Shop.vue?vue&type=style&index=0&id=102b2c67&scopded=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('102b2c67')) {
      api.createRecord('102b2c67', component.options)
    } else {
      api.reload('102b2c67', component.options)
    }
    module.hot.accept("./Shop.vue?vue&type=template&id=102b2c67", function () {
      api.rerender('102b2c67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/plugins/Shop.vue"
export default component.exports